export function getChangedLanguage(selectedLanguage) {
  return selectedLanguage === 'en' ? 'id' : 'en';
}

export function test() {}
